import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import { ListCacheManager } from '@/data/hook/query/v2/CacheFacade';
import useLessonQuestionBreadcrumb from '@/data/hook/question/useLessonQuestionBreadcrumb';
import Activity from '@/models/Activity';

import ActivityBlockCard  from './ActivityBlockCard';
import QuestionsList from './QuestionsList';
import { QuestionTypeEnum } from '@/models/Question';

type LessonActivityRowProps = {
  activity: Activity;
  isUpdating: boolean;
  onDelete: (activityId: number) => void;
  lessonId: number;
  cacheManager: ListCacheManager<Activity>;
  onUpdate?: (params: { activityId: number; data: Partial<Activity>; }) => Promise<Activity>;
  index: number;
  isDraggable?: boolean;
  isDragging?: boolean;
  isReordering?: boolean;
  allowedTypes?: QuestionTypeEnum[];
  createQuestionBtnName?: string;
};

export default function LessonActivityRow({
  activity,
  lessonId,
  cacheManager,
  isUpdating,
  onDelete,
  index,
  onUpdate,
  isDraggable,
  isDragging,
  isReordering,
  allowedTypes,
  createQuestionBtnName,
}: LessonActivityRowProps) {
  const breadcrumbItems = useLessonQuestionBreadcrumb({ activity, lessonId });

  const dragProps = isDraggable
    ? {
        isDraggable: true as const,
        id: `activity-${activity.id}`,
        index,
        disabled: isReordering,
      }
    : { isDraggable: false as const };

  return (
    <ActivityBlockCard
      className="mb-6"
      activity={activity}
      isUpdating={isUpdating}
      onUpdate={onUpdate}
      onDelete={onDelete}
      isDragging={isDragging}
      {...dragProps}
    >
      <CourseAdminCard.NestedList>
        <QuestionsList
          activity={activity}
          cacheManager={cacheManager}
          breadcrumbItems={breadcrumbItems}
          isDraggable
          allowedTypes={allowedTypes}
          createQuestionBtnName={createQuestionBtnName}
        />
      </CourseAdminCard.NestedList>
    </ActivityBlockCard>
  );
}